import React from 'react';
import { Target, Zap, TrendingUp } from 'lucide-react';

const t = {
  en: {
    label: 'WHY TRUEFITNESS',
    title: 'WHY TRUEFITNESS',
    cards: [
      {
        icon: Zap,
        title: 'Stronger in 8 Weeks',
        desc: 'Proven protocols from performance sports',
      },
      {
        icon: Target,
        title: 'Your Plan. Your Rules.',
        desc: 'Fully adapted to your level and goals',
      },
      {
        icon: TrendingUp,
        title: 'Measurable Progress',
        desc: 'Every extra kg. Every rep counts.',
      },
    ],
  },
  de: {
    label: 'WARUM TRUEFITNESS',
    title: 'WARUM TRUEFITNESS',
    cards: [
      {
        icon: Zap,
        title: 'Stärker in 8 Wochen',
        desc: 'Bewährte Protokolle aus dem Leistungssport',
      },
      {
        icon: Target,
        title: 'Dein Plan. Deine Regeln.',
        desc: 'Vollständig auf dein Niveau und deine Ziele angepasst',
      },
      {
        icon: TrendingUp,
        title: 'Messbarer Fortschritt',
        desc: 'Jedes Kg mehr. Jede Wiederholung zählt.',
      },
    ],
  },
};

export default function Benefits({ lang }) {
  const tx = t[lang];

  return (
    <section
      className="py-24 px-6"
      style={{
        background: 'linear-gradient(180deg, #0f1117 0%, #111520 50%, #0f1117 100%)',
      }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <p
            className="text-sm font-bold uppercase mb-3"
            style={{ color: '#3b82f6', letterSpacing: '0.2em' }}
          >
            {tx.label}
          </p>
          <h2
            className="font-black uppercase"
            style={{
              fontSize: 'clamp(1.8rem, 4vw, 3rem)',
              letterSpacing: '-0.02em',
              color: '#ffffff',
            }}
          >
            {tx.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {tx.cards.map((card, i) => {
            const Icon = card.icon;
            const isMiddle = i === 1;
            return (
              <div
                key={i}
                className="relative rounded-2xl p-8 flex flex-col gap-5 transition-transform duration-300 hover:-translate-y-1"
                style={{
                  background: isMiddle
                    ? 'linear-gradient(135deg, #1e3a6e 0%, #1a2d5a 100%)'
                    : 'linear-gradient(135deg, #1a1d27 0%, #141620 100%)',
                  border: isMiddle
                    ? '1px solid rgba(59,130,246,0.5)'
                    : '1px solid rgba(255,255,255,0.07)',
                  boxShadow: isMiddle ? '0 0 60px rgba(59,130,246,0.15)' : 'none',
                }}
              >
                {/* Icon */}
                <div
                  className="flex items-center justify-center rounded-xl"
                  style={{
                    width: 52,
                    height: 52,
                    background: isMiddle
                      ? 'rgba(59,130,246,0.3)'
                      : 'rgba(59,130,246,0.12)',
                    border: '1px solid rgba(59,130,246,0.3)',
                  }}
                >
                  <Icon size={24} color={isMiddle ? '#ffffff' : '#3b82f6'} strokeWidth={2} />
                </div>

                <h3
                  className="font-black uppercase"
                  style={{
                    fontSize: '1.15rem',
                    letterSpacing: '0.05em',
                    color: '#ffffff',
                  }}
                >
                  {card.title}
                </h3>

                <p
                  className="leading-relaxed text-sm"
                  style={{ color: isMiddle ? '#bfdbfe' : '#64748b' }}
                >
                  {card.desc}
                </p>

                {/* Bottom accent line */}
                <div
                  className="absolute bottom-0 left-8 right-8 h-px"
                  style={{
                    background: isMiddle
                      ? 'linear-gradient(to right, transparent, #3b82f6, transparent)'
                      : 'linear-gradient(to right, transparent, rgba(59,130,246,0.3), transparent)',
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
